import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admin guard — check localStorage flag set at login for admin accounts.
  // Backend enforcement is the real gate; this is UX-only.
  if (requireAdmin && localStorage.getItem("gs_is_admin") !== "true") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
